import { redirect } from 'react-router-dom';

import { cookieJar, uiRoutes } from '@consumer-frontend/nc-api';

export const authenticatedGuard = async () => {
  const hasAccessToken = !!cookieJar.getAccessToken();

  if (!hasAccessToken) {
    throw redirect(uiRoutes.apply.borrowingNeeds);
  }
};
